import { FC, useEffect } from 'react';
import { Loading } from 'mir-utils/components';
import { ThemeProvider as MaterialThemeProvider, StyledEngineProvider } from '@mui/material';
import { useMobileMatch } from 'mir-utils/hooks';
import { notNull } from 'mir-utils/utils/utilities';
import { useVersion } from 'mir-utils/api-tools';
import { useTranslation } from 'mir-utils/i18n';
import {
  getGoogleAnaliticTemplate,
  getYandexMetrikaTemplate,
  getRoistatTemplate,
} from './metrikaTemplates';
import { getTheme } from '.';

export const ThemeProvider: FC = ({ children }) => {
  const mobileVersion = useMobileMatch();
  const { t } = useTranslation();

  const version = useVersion();

  useEffect(() => {
    if (version !== undefined) {
      const favicon = notNull(document.getElementById('favicon')) as HTMLLinkElement;
      const googleAnaliticsScript = notNull(
        document.getElementById('google-analytic')
      ) as HTMLScriptElement;
      const yandexMetrikaScript = notNull(
        document.getElementById('yandex-metrika')
      ) as HTMLScriptElement;
      const roistatScript = notNull(document.getElementById('roistat')) as HTMLScriptElement;

      if (version.googleAnalyticsId) {
        googleAnaliticsScript.innerHTML = getGoogleAnaliticTemplate(version);
      }

      if (version.yandexMetrikaId) {
        yandexMetrikaScript.innerHTML = getYandexMetrikaTemplate(version);
      }

      if (version.roistatKey) {
        roistatScript.innerHTML = getRoistatTemplate(version);
      }

      favicon.href = version.faviconPath;
    }
  }, [version]);

  useEffect(() => {
    const metaDescription = document.createElement('meta');

    metaDescription.name = 'description';
    metaDescription.content = t('Download Ideco NGFW and install it on your server or hypervisor.');

    document.head.prepend(metaDescription);
  }, []);

  if (version === undefined) {
    return <Loading />;
  }

  const responsiveTheme = getTheme(version.themeColors, version.language);

  if (mobileVersion) {
    if (responsiveTheme.components?.MuiTextField?.styleOverrides?.root) {
      responsiveTheme.components.MuiTextField.styleOverrides.root = {
        ...(responsiveTheme.components.MuiTextField.styleOverrides.root as any),
        width: 270,
      };
    }
  }

  return (
    <StyledEngineProvider injectFirst>
      <MaterialThemeProvider theme={responsiveTheme}>{children}</MaterialThemeProvider>
    </StyledEngineProvider>
  );
};
